import {apiBaseUrl} from "../AppHelpers/AppEnv";

const BASE_URL = apiBaseUrl();

if (!BASE_URL) {
    // public/config.js missing or not loaded — otherwise every URL below would
    // silently resolve against "undefined/...".
    console.error('APP_CONFIG.apiBaseUrl is not set. Check that config.js is served.');
} else {
    console.info('API base URL:', BASE_URL);
}

export const URLS = {
    LOGIN: BASE_URL + '/login',
    REQUIRE_SIGNING: BASE_URL + '/receipts/require-signing/',
    SHOW: BASE_URL + '/receipts/show/',
    SAVE_SIGNATURE: BASE_URL + '/receipts/save-signature/',
    MARK_SIGNED: BASE_URL + '/receipts/mark-signed/',
    MARK_CANCELLED: BASE_URL + '/receipts/mark-cancelled/',
    RESPONSES: BASE_URL + '/responses',
    ADVERTISEMENTS: BASE_URL + '/advertisements',
};
